import React from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, Clock, DollarSign, File, ArrowLeft } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams } from 'react-router-dom';
export function AuctionDetailPage() {
  const {
    id
  } = useParams();
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  return <DashboardLayout title="Auction Management" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2369">
      <div className="mb-6" data-id="element-2370">
        <Link to="/authority/auctions" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-4" data-id="element-2371">
          <ArrowLeft className="w-4 h-4" data-id="element-2372" /> Back to Auctions
        </Link>
        <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-2373">
          <div data-id="element-2374">
            <h1 className="text-2xl font-bold mb-1" data-id="element-2375">
              Auction #{id || 'AUC-001'}
            </h1>
            <p className="text-gray-500 font-mono text-sm" data-id="element-2376">
              Hinjewadi Phase 3 • Commercial Plot #42
            </p>
          </div>
          <div className="flex gap-3" data-id="element-2377">
            <button className="px-4 py-2 border border-red-300 bg-red-50 text-red-700 text-sm font-bold hover:bg-red-100" data-id="element-2378">
              Cancel Auction
            </button>
            <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2379">
              Extend Deadline
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2380">
        <div className="lg:col-span-2 space-y-8" data-id="element-2381">
          {/* Bidder List */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-2382">
            <h2 className="font-bold text-lg mb-4" data-id="element-2383">Bid History</h2>
            <div className="overflow-x-auto" data-id="element-2384">
              <table className="w-full text-left text-sm" data-id="element-2385">
                <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-2386">
                  <tr data-id="element-2387">
                    <th className="p-3 font-bold" data-id="element-2388">Bidder</th>
                    <th className="p-3 font-bold" data-id="element-2389">Amount</th>
                    <th className="p-3 font-bold" data-id="element-2390">Time</th>
                    <th className="p-3 font-bold" data-id="element-2391">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-2392">
                  {[{
                  name: 'Sunrise Developers',
                  amt: '₹ 1.45 Cr',
                  time: '10 mins ago',
                  status: 'Leading'
                }, {
                  name: 'Urban Spaces Ltd',
                  amt: '₹ 1.42 Cr',
                  time: '1 hour ago',
                  status: 'Outbid'
                }, {
                  name: 'Raj Realty',
                  amt: '₹ 1.35 Cr',
                  time: '3 hours ago',
                  status: 'Outbid'
                }].map((bid, i) => <tr key={i} className={i === 0 ? 'bg-green-50/50' : ''} data-id="element-2393">
                      <td className="p-3 font-bold" data-id="element-2394">{bid.name}</td>
                      <td className="p-3 font-mono font-bold" data-id="element-2395">{bid.amt}</td>
                      <td className="p-3 text-gray-500 text-xs" data-id="element-2396">{bid.time}</td>
                      <td className="p-3" data-id="element-2397">
                        <span className={`text-xs font-bold ${i === 0 ? 'text-green-600' : 'text-gray-500'}`} data-id="element-2398">
                          {bid.status}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {/* Documents */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-2399">
            <h2 className="font-bold text-lg mb-4" data-id="element-2400">Auction Documents</h2>
            <div className="space-y-2" data-id="element-2401">
              {['Plot_Map_Survey_42.pdf', 'Legal_Clearance_Cert.pdf', 'Auction_Terms_v2.pdf'].map((doc, i) => <div key={i} className="flex items-center justify-between p-3 border border-gray-200 bg-gray-50" data-id="element-2402">
                  <div className="flex items-center gap-3" data-id="element-2403">
                    <File className="w-4 h-4 text-gray-400" data-id="element-2404" />
                    <span className="text-sm font-mono" data-id="element-2405">{doc}</span>
                  </div>
                  <button className="text-blue-600 text-xs font-bold hover:underline" data-id="element-2406">
                    Download
                  </button>
                </div>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-2407">
          <div className="bg-white border border-gray-300 p-6" data-id="element-2408">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-2409">
              Current Highest Bid
            </h3>
            <div className="flex items-center gap-2 mb-1" data-id="element-2410">
              <DollarSign className="w-6 h-6 text-green-600" data-id="element-2411" />
              <span className="text-3xl font-bold text-[#1f2933]" data-id="element-2412">
                ₹ 1.45 Cr
              </span>
            </div>
            <p className="text-sm text-gray-500" data-id="element-2413">Base Price: ₹ 1.20 Cr</p>
          </div>

          <div className="bg-white border border-gray-300 p-6" data-id="element-2414">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-2415">
              Time Remaining
            </h3>
            <div className="flex items-center gap-2 mb-1" data-id="element-2416">
              <Clock className="w-6 h-6 text-orange-600" data-id="element-2417" />
              <span className="text-3xl font-bold text-[#1f2933]" data-id="element-2418">
                02:14:55
              </span>
            </div>
            <p className="text-sm text-gray-500" data-id="element-2419">Ends: Oct 25, 2024 5:00 PM</p>
          </div>

          <div className="bg-gray-100 p-6 border border-gray-300" data-id="element-2420">
            <h3 className="font-bold text-sm mb-2" data-id="element-2421">Auction Notes</h3>
            <p className="text-xs text-gray-600 leading-relaxed" data-id="element-2422">
              Minimum increment is ₹ 1 Lakh. Winner must deposit 10% within 24
              hours.
            </p>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}